import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { accountService } from '@/service/api/account.service';

export interface IResetPasswordState {
  token: string; // トークン
  email: string; // Eメール
  password: string; // パスワード
  passwordConfirm: string; // 確認用パスワード
}
@Module({ dynamic: true, store, name: 'resetPasswordModule', namespaced: true })
class ResetPasswordModule extends VuexModule implements IResetPasswordState {
  token: string = '';
  email: string = '';
  password: string = '';
  passwordConfirm: string = '';

  get isDifferentPassword(): boolean {
    return this.password != this.passwordConfirm;
  }

  @Mutation
  setToken(value: string) {
    this.token = value;
  }
  @Mutation
  setEmail(value: string) {
    this.email = value;
  }
  @Mutation
  setPassword(value: string) {
    this.password = value;
  }

  @Mutation
  setPasswordConfirm(value: string) {
    this.passwordConfirm = value;
  }

  /**
   * リセットメール送信
   */
  @Action({ rawError: true })
  sendEmail() {
    return accountService.sendResetPasswordEmail(this.email);
  }

  /**
   * リセット対象メール取得
   */
  @Action({ rawError: true })
  fetchResetPasswordEmail() {
    return accountService.getResetPasswordEmail(this.token);
  }

  /**
   * パスワードリセット
   */
  @Action({ rawError: true })
  resetPassword() {
    return accountService.resetPassword(this.password, this.token);
  }
}

export const resetPasswordModule = getModule(ResetPasswordModule);
